<script>
    export let open = false;
    export let imageUrl = "";
    export let onClose = () => {};

    let imgLoadError = false;

    $: if (open) {
        imgLoadError = false;
    }
</script>

{#if open}
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="overlay" on:click={onClose}>
        <div class="modal" on:click|stopPropagation>
            <button type="button" class="close-btn" on:click={onClose} aria-label="닫기">✕</button>
            {#if imageUrl && !imgLoadError}
                <!-- svelte-ignore a11y-img-redundant-alt -->
                <img
                    src={imageUrl}
                    alt="부품 사진"
                    on:click={onClose}
                    on:error={() => (imgLoadError = true)}
                />
            {:else}
                <div class="empty-photo">
                    <p>등록된 부품 이미지가 없습니다.</p>
                </div>
            {/if}
        </div>
    </div>
{/if}

<style>
    .overlay {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000002;
    }
    .modal {
        position: relative;
        background: #fff;
        padding: 24px 16px 16px 16px;
        border-radius: 12px;
        width: 90vw;
        max-width: 440px;
        max-height: 80vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.5);
        box-sizing: border-box;
    }
    .close-btn {
        position: absolute;
        top: 8px;
        right: 8px;
        background: #1E293B;
        color: #FFF;
        border: none;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        font-size: 16px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 10;
        box-shadow: 0 2px 5px rgba(0,0,0,0.3);
    }
    .modal img {
        max-width: 100%;
        max-height: 65vh;
        object-fit: contain;
        cursor: pointer;
        border-radius: 6px;
    }
    .empty-photo {
        padding: 40px 20px;
        text-align: center;
        color: #64748B;
        font-size: 14px;
    }
</style>
